import {
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation,
    ChangeDetectorRef
} from '@angular/core';

/**
 * Form message component.
 */
@Component({
    selector: 'ihd-form-message',
    templateUrl: './form-message.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    styleUrls: [
        './form-message.component.scss'
    ],
    host: {
        'class': 'c-form-message',
        '[class.is-hidden]': '!hasError'
    }
})
export class FormMessageComponent {

    @Input() public name: string;
    @Input() public hasError: boolean = false;
    @Input() public translationKey: string;

    public translationValues: any;

    constructor(private cdr: ChangeDetectorRef) {
    }

    public setTranslationValues(values: any) {
        this.translationValues = values;
        this.cdr.markForCheck();
    }
}
